<uc-main-header
	heading="All the information you need at your fingertips"
	description="Find tips for your personal statement, university halls advice, student finance advice, guidance for teachers and more."
	backgroundStyle="bg-advice"
>
	<div class="py-6">
		<uc-search-bar
			[keyword]="searchTerm"
			[displayButton]="true"
			placeholder="Search Articles"
		/>
	</div>
</uc-main-header>

<!-- Advice Main Content -->
<div class="bg-white">
	<!-- mobile sort -->
	<div class="relative px-4 py-5 mb-6 bg-white border-b sm:hidden">
		<uc-sort [sortOptions]="sortOptions" buttonWidth="w-full" />
	</div>

	@if (loadingSearch) {
		<div class="container py-12">
			<uc-loading-animation [htmlString]="loadingHtml" />
		</div>
	}

	<div
		[ngStyle]="{ visibility: loadingSearch ? 'hidden' : 'visible' }"
		class="container"
	>
		@if (searchResult$ | async; as search) {
			<div class="sm:flex sm:pt-12 md:pt-16 sm:flex-row sm:justify-between">
				<!-- count of results-->
				<p class="text-xl font-bold sm:text-2xl">
					{{ search?.results_count }} Articles found
					@if (searchTerm) {
						for "<span class="capitalize">{{ searchTerm }}</span
						>"
					}
				</p>
				<!--desktop sort -->
				<div class="hidden sm:block">
					<uc-sort [sortOptions]="sortOptions" />
				</div>
			</div>
			<!-- search result / showing the latest articles -->
			@for (article of articles; track article; let i = $index) {
				<div #articleEle [attr.id]="'article' + i" class="divider">
					<uc-advice-featured-card [article]="article" />
				</div>
			}
			<!-- Load more button-->
			@if (search?.data?.length < search?.results_count) {
				<div class="pt-5 pb-8 sm:pt-12 sm:pb-16">
					<uc-load-more-btn [isLoading]="loadMore" [page]="page" />
				</div>
			}
			<!-- no result -->
			@if (search?.results_count === 0) {
				<div class="divider !border-b-0">
					<div
						class="pb-12 text-center border border-gray-200 rounded-lg x-6 pt-7"
					>
						<uc-sad-face-svg />
						<h3 class="mt-12 text-lg font-bold">
							It looks like your search didn't bring back any results
						</h3>
						<p class="text-gray-500">Try entering 'GCSE' or 'A Levels'.</p>
					</div>
				</div>
			}
		}
	</div>
</div>
